import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MarketingCampaign } from "../models/entities/marketing-campaign.model";
import { MarketingCampaignForm } from "../models/pages/participant-details/marketing-info.model";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useUpdateMarketingCampaigns = () => {
	const queryClient = useQueryClient();

	return useMutation({
		onSettled: () => {
			queryClient.invalidateQueries({
				queryKey: ["marketing-campaigns"],
			});
		},
		mutationFn: async ({
			patientId,
			campaigns,
			initialData,
		}: {
			patientId: number;
			campaigns: MarketingCampaign[];
			initialData: MarketingCampaignForm | undefined;
		}) => {
			await EndpointsService.dataRetriever.updatePatientCampaignStatus({
				patientId: patientId,
				body: campaigns.filter((campaign) => {
					const initialCampaign = initialData?.campaigns.find(
						(item) => item.name === campaign.name
					);
					return initialCampaign && initialCampaign.paused !== campaign.paused;
				}),
			});
		},
	});
};
